// extracted by mini-css-extract-plugin
export default {"qrCodeWrap":"qrCodeWrap_BF8KD","fakeQrCodeWrap":"fakeQrCodeWrap_mO3tq","qrCodeMask":"qrCodeMask_aWihQ","fakeQrCode":"fakeQrCode_FAdTY"};